import getSectionTitle from 'apps/fops/utils/getSectionTitle';
import SectionType from 'apps/catalogue/models/SectionType';

const getSectionAttributes = (section, containerType = null) => {
  if (typeof section === 'string') {
    return { title: section };
  }

  return {
    ...section.attributes,
    type: section.attributes.type || containerType,
  };
};

export default function getAnalyticsSectionTitle(section, pageType, containerType = null) {
  const sectionAttributes = getSectionAttributes(section, containerType);

  if (sectionAttributes.type === SectionType.CLUSTER) {
    return pageType;
  }
  return getSectionTitle(sectionAttributes) || pageType;
}
